<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-cart-auth-modal></app-cart-auth-modal>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>